import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { TemplatesCatalogKey } from './templates.i18n.js';
import { TEMPLATES_CATALOG } from './templates.i18n.js';

export type TemplatesMessageId = `templates:${TemplatesCatalogKey}`;

const PREFIX_LENGTH = 'templates:'.length;

/** `t()` for the stop-gap `templates:` scope (see `templates.i18n.ts`). */
export function useTemplatesT(): { t: (id: TemplatesMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: TemplatesMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as TemplatesCatalogKey;
      const raw = TEMPLATES_CATALOG[locale][key] ?? TEMPLATES_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
